import { Injectable, inject } from '@angular/core'
import { KeycloakService } from 'keycloak-angular'

export enum TcdRole {
  Read = 'read',
  Update = 'update',
  Create = 'create',
  Delete = 'delete',
}

@Injectable({ providedIn: 'root' })
export class RoleService {
  private keycloak = inject(KeycloakService)

  private get roles(): string[] {
    const keycloakInstance = this.keycloak.getKeycloakInstance()
    const tokenParsed = keycloakInstance?.tokenParsed
    const resourceAccess = tokenParsed?.resource_access
    const clientId = keycloakInstance?.clientId

    if (resourceAccess && clientId && resourceAccess[clientId]) {
      return resourceAccess[clientId].roles || []
    }
    return []
  }

  get canRead(): boolean {
    return this.roles.includes(TcdRole.Read)
  }

  get canEdit(): boolean {
    return this.roles.includes(TcdRole.Update)
  }

  get canCreate(): boolean {
    return this.roles.includes(TcdRole.Create)
  }

  get canDelete(): boolean {
    return this.roles.includes(TcdRole.Delete)
  }
}
